import {Component, OnInit} from '@angular/core';
import {CommonConstants} from '../../util/common-constants';
import {AuthService} from '../../service/auth/auth.service';
import {ScreenService} from '../../service/screen/screen.service';
import {NavigationService} from '../../service/navigation/navigation.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-gridnav',
  templateUrl: './gridnav.component.html',
  styleUrls: ['./gridnav.component.css']
})
export class GridnavComponent implements OnInit {

  expandBreadcrumb = true;

  constructor(public constants: CommonConstants,
              public authService: AuthService,
              public screenService: ScreenService,
              private navService: NavigationService,
              private snackbar: MatSnackBar) {
  }

  ngOnInit(): void {
  }

}
